// import { Http, Headers, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/operators';
// import { IOperationResult } from '../models/interfaces/IOperationResult';
import { EncryptedService } from './common/encrypted.services';
import { map } from 'rxjs/operators';
import { AdditionalbaseService } from './common/additionalbase.service';
// import { LoginService } from './generalQuote/login/login.service';
// import { ShareService } from './generalQuote/share.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export class BaseService {
  // public http: HttpClient;
  public document_name: string;
  public base_url: string = '';
  public Encrypt: EncryptedService = new EncryptedService();
  public token: any;


  constructor(
    public httpClient: HttpClient,
    public _additionalService: AdditionalbaseService,
    document_name: string,
    // public _sharedService: ShareService
  ) {
    this.httpClient = httpClient;
    this.document_name = document_name;

  }

    getOptions() {
    const token = localStorage.getItem('token');
    
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    if (token && token !== "null") {
      headers = headers.append('Authorization', token);
    }
    
    return { headers: headers };
  }

  // Lista de Operaciones Adaptadas Disponibles
  list() {
    return this.request('get', this.base_url);
  }
  get(_id: string) {
    return this.request('get', `/${_id}`);
  }
  optain(_id: string, _object: any) {
    return this.request('post', `/${_id}`, _object);
  }
  save(_object: any) {
    return this.request('post', '', _object);
  }
  saveP1(_object: any) {
    return this.request('post', `?user=vcerda`, _object);
  }
  saveP(_id: string, _id2: string) {
    return this.request('post', `/${_id}/${_id2}`);
  }
  update(_id: string, _object: any) {
    return this.request('put', `/${_id}`, _object);
  }
  delete(_id: string) {
    return this.request('delete', `/${_id}`);
  }

  filter(params: any) {
    return this.request('get', params);
  }
  size(params: any) {
    return this.request('post', `/size`, params);
  }

  // Funciones genericas
  SC_Route_Buscar(OBJECT: any, ROUTE: string, _Async: string = ''): Observable<any> {
    const url: string = ROUTE + `/SC_Buscar${_Async}`;

    return this._additionalService.wrapperObservable(
      this.request('post', url, OBJECT)
    );
  }

  private request(method: any, url: string, _object?: any, headers?: any) {

    let requestTrigger: any;
    const request: Observable<any> = new Observable<any>(
      observable => {
        requestTrigger = observable;
      }
    );
    let fullUrl: string;

    fullUrl = environment.endpoint_auth + url;

    let httpRequest;

    if (method === 'post') {
      httpRequest = this.httpClient.post(fullUrl, _object, this.getOptions());
    }

    if (method === 'put') {
      httpRequest = this.httpClient.put(fullUrl, _object, this.getOptions());
    }

    if (method === 'get') {
      httpRequest = this.httpClient.get(fullUrl, this.getOptions());
    }


    httpRequest.pipe().subscribe(
      (response: any) => {
        requestTrigger.next(response);
        requestTrigger.complete();
      },
      (err: any) => {
        requestTrigger.next(err);
        requestTrigger.complete();
      }
    );


    return request;
  }

}

export interface IJsonResponse {
  _body: string;
  status: number;
  ok: boolean;
  statusText: string;
  url: string;
  type: number;
  header: object;
}
